import { RingFull, RingHalf, RingQuarter } from "./GeoShapes";

const ITEMS = [
  "Food & Beverage Branding",
  "Label Design",
  "Packaging",
  "Brand Identity",
  "Wine & Spirits",
  "Dallo scaffale al digitale",
  "Bari / Puglia / Remoto",
  "Sistemi visivi coerenti",
];

const Strip = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item, i) => (
      <span key={item} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-display text-2xl font-bold tracking-tight text-paper sm:text-3xl">
          {item}
        </span>
        {i % 3 === 0 && <RingHalf className="h-6 w-6" />}
        {i % 3 === 1 && <span className="h-5 w-5 bg-magenta-brand" />}
        {i % 3 === 2 && <RingQuarter className="h-6 w-6" />}
      </span>
    ))}
    <RingFull className="mx-2 h-6 w-6" />
  </div>
);

export default function EditorialMarquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-ink bg-ink py-5"
    >
      <div className="animate-marquee flex w-max">
        <Strip />
        <Strip />
      </div>
    </div>
  );
}
